import styled from 'styled-components';
import SvgArrowLeft from '../../../others/svg_dist/ArrowLeft';

export const Wrapper = styled.div`
	display: flex;
	flex-flow: column nowrap;
	width: 100%;
`;

export const ContentContainer = styled.div`
	width: 100%;
	margin-top: 25px;
	background-color: #f5f5f5;
	margin-bottom: 100px;
	@media screen and (max-width: 650px) {
		margin-bottom: 0;
	}
`;

export const NextContainer = styled.div`
	width: 80%;
	height: 150px;
	background-image: linear-gradient(45deg, #004583, #0063a5);
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 0 auto;
	transform: translateY(50%);
	border-radius: 150px;
	@media screen and (max-width: 650px) {
		width: 100%;
		background: none;
		transform: unset;
		& > div {
			font-size: 12px !important;
			margin: 0 10px !important;
		}
	}
`;

export const ButtonIconContainer = styled.div`
	position: absolute;
	right: 0;
	top: 0;
	width: 75px;
	height: 100%;
	background: rgb(2 80 144);
	border-radius: 0 120px 120px 0;
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const NextButtonIcon = (
	<ButtonIconContainer>
		<SvgArrowLeft
			style={{
				width: 25,
				height: 25,
				fill: '#f8f96f',
				position: 'static',
				top: 'unset',
				right: 'unset',
				transform: 'unset',
			}}
		/>
	</ButtonIconContainer>
);

export const getNextButtonStyle = (disabled: boolean): React.CSSProperties => ({
	width: 390,
	textAlign: 'center',
	paddingRight: 100,
	border: '2px solid #F8F96F',
	background: '#F8F96F',
	fontWeight: '600',
	color: '#055090',
	lineHeight: '1.3',
	cursor: disabled ? 'not-allowed' : 'pointer',
	opacity: disabled ? '0.6' : '1',
});

export const ReceiptRail = styled.div`
	width: fit-content;
	position: relative;
	@media screen and (max-width: 900px) {
		display: none;
	}
`;

export const ContentSectionsContainer = styled.div`
	display: flex;
	width: 90%;
	margin: 0 auto;
	justify-content: center;
	@media screen and (max-width: 650px) {
		width: calc(100% - 10px);
		margin: 0 5px;
	}
`;
